import { render, staticRenderFns } from "./SettingsPartner.vue?vue&type=template&id=1f4a9b6e&scoped=true&"
import script from "./SettingsPartner.vue?vue&type=script&lang=js&"
export * from "./SettingsPartner.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPartner.vue?vue&type=style&index=0&id=1f4a9b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4a9b6e",
  null
  
)

export default component.exports